import constants from 'config/constants';
import { hostIsYuhuProd } from 'helpers/CurrentWindowLocation';

const redirectUri = constants.ENV === 'local' ? 'http://localhost' : `${constants.BASE_API_URL}/v1`;

export default {
  client_id: hostIsYuhuProd()
    ? 'd45f55f9-d693-43f2-94d7-c94e1b09e64d'
    : 'cd54490f-0ee8-4fae-89a0-fa3ee352dbb5',
  redirect_uri: `${redirectUri}/oauth/azure`,
  response_type: 'code',
  response_mode: 'query',
  scope: 'offline_access User.read Calendars.ReadWrite Calendars.ReadWrite.Shared',
  oauth_route: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
  state: 'azure',
};
